// extracted by mini-css-extract-plugin
module.exports = {"root":"_7b2412","articlesRoot":"_863e21","cardItem":"_b0d776"};